// -----------Important-----------------------------------------------------------
// -------------------------------------------------------------------------------
// -------------------------------------------------------------------------------
// ------------update pathes after add new root or path-pages---------------------
// -------------------------------------------------------------------------------
// -------------------------------------------------------------------------------
// -------------------------------------------------------------------------------
// -------------------------------------------------------------------------------
// -------------------------------------------------------------------------------
function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  register: path(ROOTS_AUTH, "/register"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
  verify: path(ROOTS_AUTH, "/verify"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  newPassword: path(ROOTS_AUTH, "/new-password"),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  payment: "/payment",
  about: "/about-us",
  cal: "/cal",
  start: "/start",
  visas: (id) => path(`${id}`),
  helps: (id) => path(`${id}`),
  contact: "/contact-us",
  terms: "/terms",
  privacy: "/privacy",
  careers: "/careers",
  faqs: "/faqs",
  page403: "/403",
  page404: "/404",
  page500: "/500",
  experts: "/experts",
  profile: (id) => path(`${id}`),
  posts: (postID) => path(`posts/${postID}`),
  assessmentView: (id) => path(`applicants/${id}`),
  clientView: (id) => path(`clients/${id}`),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, "/mail"),
    all: path(ROOTS_DASHBOARD, "/mail/all"),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, "/chat"),
    // new: path(ROOTS_DASHBOARD, "/chat/new"),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, "/calendar"),
  permissionDenied: path(ROOTS_DASHBOARD, "/permission-denied"),
  user: {
    root: path(ROOTS_DASHBOARD, "/user"),
    new: path(ROOTS_DASHBOARD, "/user/new"),
    list: path(ROOTS_DASHBOARD, "/user/list"),
    cards: path(ROOTS_DASHBOARD, "/user/cards"),
    applicant: path(ROOTS_DASHBOARD, `/user/applicant`),
    applicantbg: path(ROOTS_DASHBOARD, `/user/applicantbg`),
    applicantdoc: path(ROOTS_DASHBOARD, `/user/applicantdoc`),

    spouse: path(ROOTS_DASHBOARD, `/user/spouse`),
    spousebg: path(ROOTS_DASHBOARD, `/user/spousebg`),
    spousedoc: path(ROOTS_DASHBOARD, `/user/spousedoc`),

    fspouse: path(ROOTS_DASHBOARD, `/user/fspouse`),
    fspousebg: path(ROOTS_DASHBOARD, `/user/fspousebg`),
    fspousedoc: path(ROOTS_DASHBOARD, `/user/fspousedoc`),

    children: path(ROOTS_DASHBOARD, `/user/children`),
    documents: path(ROOTS_DASHBOARD, "/user/documents"),
    account: path(ROOTS_DASHBOARD, "/user/account"),
    subscription: path(ROOTS_DASHBOARD, "/user/subscription"),
    assessment: path(ROOTS_DASHBOARD, "/user/assessment"),
  },

  invoice: {
    root: path(ROOTS_DASHBOARD, "/invoice"),
    list: path(ROOTS_DASHBOARD, "/invoice/list"),
    new: path(ROOTS_DASHBOARD, "/invoice/new"),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, "/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit"),
    demoView: path(ROOTS_DASHBOARD, "/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5"),
  },
  profile: {
    root: path(ROOTS_DASHBOARD, "/profile"),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, "/blog"),
    posts: path(ROOTS_DASHBOARD, "/blog/posts"),
    new: path(ROOTS_DASHBOARD, "/blog/new"),
    view: (title, userName) => path(`/${userName}/blog/${title}`),
  },
  service: {
    root: path(ROOTS_DASHBOARD, "/service"),
    services: path(ROOTS_DASHBOARD, "/service/services"),
    new: path(ROOTS_DASHBOARD, "/service/new"),
  },
  contact: {
    root: path(ROOTS_DASHBOARD, "/contact"),
    contacts: path(ROOTS_DASHBOARD, "/contact/contacts"),
    new: path(ROOTS_DASHBOARD, "/contact/new"),
    view: (title) => path(`/contact/edit/${title}`),
    contact: (title) => path(`/contact/${title}`),
  },
};

export const Pathes = [
  "terms",
  "privacy",
  "careers",
  "start",
  "visas",
  "helps",
  "coming-soon",
  "maintenance",
  "pricing",
  "payment",
  "about-us",
  "contact-us",
  "faqs",
  "403",
  "404",
  "500",
  "consultants",
  "experts",
  "applicants",
  "clients",
  "auth",
  "dashboard",
];
